export default {
  create: {
    success: '{name} created.',
    success_simple: 'Created.',
    error: 'Failed to create {name}.',
    error_simple: 'Create failed.',
  },
  save: {
    success: '{name} saved.',
    success_simple: 'Saved.',
    error: 'Failed to save {name}.',
    error_simple: 'Save failed.',
  },
  change: {
    success: '{name} changed.',
    success_simple: 'Changed.',
    error: 'Failed to change {name}.',
    error_simple: 'Change failed.',
  },
  update: {
    success: '{name} updated.',
    success_simple: 'Updated.',
    error: 'Failed to update {name}.',
    error_simple: 'Update failed.',
  },
  delete: {
    success: '{name} deleted.',
    success_simple: 'Deleted.',
    error: 'Failed to delete {name}.',
    error_simple: 'Delete failed.',
  },
  fetch: {
    success: '{name} fetched.',
    success_simple: 'Fetched.',
    error: 'Failed to fetch {name}.',
    error_simple: 'Fetch failed.',
  },
  register: {
    success: '{name} registered.',
    success_simple: 'Registered.',
    error: 'Failed to register {name}.',
    error_simple: 'Register failed.',
  },
  add: {
    success: '{name} added.',
    success_simple: 'Added.',
    error: 'Failed to add {name}.',
    error_simple: 'Add failed.',
  },
  access: {
    success: 'Accessed to {name}.',
    success_simple: 'Accessed.',
    error: 'Failed to access to {name}.',
    error_simple: 'Access failed.',
  },
  default: {
    success: 'Success!',
    error: 'Failed...',
  },
};
